import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export class PhoneNumberValidator {
    /**
     * check ob mindestens eine Telefonnumer angegeben ist
     */
    public static atLeastOneFilled(festnetzFormField: string, mobilFormField: string): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const festnetz = group.get(festnetzFormField)?.value;
            const mobil = group.get(mobilFormField)?.value;

            const atLeastOneFilled = festnetz || mobil;

            return atLeastOneFilled ? null : { phoneNumberValidator: true };
        }
    }
}
